import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      name: "home",
      component: HomeView,
    },
    {
      path: "/auth-game",
      name: "auth",
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("../views/Auth.vue"),
    },
    {
      path: "/verify",
      name: "verify",
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("../views/Verify.vue"),
    },
  ],
});
const storage = window.localStorage;
function getAccessId() {
  const uid = storage.getItem("game-uid");

  return uid;
}
function getAuth() {
  const isAuth = storage.getItem("game-auth");

  return isAuth;
}
router.beforeEach((to, from, next) => {
  if (to.name === "auth") {
    if (getAccessId()) {
      if (!getAuth()) {
        return next({ name: "verify" });
      } else {
        return next("/");
      }
    }
    return next();
  }
  if (to.name === "verify") {
    if (getAccessId() && !getAuth()) {
      return next();
    }
    return next({ name: "auth" });
  }

  if (getAccessId()) {
    if (!getAuth()) {
      return next({ name: "verify" });
    } else {
      return next();
    }
  }
  return next({ name: "auth" });
});

export default router;
